import React, {useCallback} from 'react';
import {MARKOV} from "pattern/groups/transformations.js";

export const useEdgeDragging = ({setTransformationEdgeDragging, track}) => {
    const startDragging = useCallback((t) => {
        setTransformationEdgeDragging({
            transformation: t
        });
    }, []);

    const endDragging = useCallback((t) => {
        let dragging = track.sequencerEngine.state.groups.transformationEdgeDragging;
        if (!dragging) {
            return;
        }
        let {transformation} = dragging;
        if (transformation === t) {
            // we can't connect markov to itself so return
            setTransformationEdgeDragging(undefined);
            return;
        }

        t.whenType = MARKOV;
        t.whenValue.set(transformation.id);
        track.updateSteps();
        setTransformationEdgeDragging(undefined);
    }, [track]);


    return {startDragging, endDragging};
};
